import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import ScrollToTop from '../src/components/ScrollToTop';
import { getAppInsights } from './telemetry/TelemetryService';
import TelemetryProvider from './telemetry/telemetry-provider';
import RetirementPage from './components/Retirement/RetirementPage';

export const App = () => {
    // let appInsights = null;
    const [clientSideSettings] = useState(
        JSON.parse(localStorage.getItem('ClientSideSettings'))
    );
    const [seconds, setSeconds] = useState(6000);
    console.log('clientSideSettings', clientSideSettings);
    // let applicationInsightKey = clientSideSettings['instrumentationKey'] ?? '';
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isActive) {
            interval = setInterval(() => {
                if (seconds === 0) logout();
                else setSeconds((seconds) => seconds - 1);
            }, 1000);
        } else if (!isActive && seconds !== 0 && seconds !== null) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isActive, seconds]);

    return (
        <Router>
            {/* <TelemetryProvider
                instrumentationKey={applicationInsightKey}
                after={() => {
                    appInsights = getAppInsights();
                }}
            > */}
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<RetirementPage />} />
                <Route path="*" element={<RetirementPage />} />
            </Routes>
            {/* </TelemetryProvider> */}
        </Router>
    );
};
